export default __webpack_public_path__ + "static/media/img2.cd425083.png";